import React, { useEffect, useMemo, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import API_BASE_URL from "../config";
import { clearAuthSession, getStoredToken, setAuthSession } from "../utils/authStorage";

const PrivateRoute = ({ children }) => {
  const location = useLocation();
  const [bootstrappingDemo, setBootstrappingDemo] = useState(true);

  const hostname = window.location.hostname.toLowerCase();
  const params = new URLSearchParams(location.search);
  const demoToken = params.get("demo_token");
  const demoSession = localStorage.getItem("demoSession");

  const isSubdomainHost = useMemo(() => {
    return (
      hostname !== "agentbookcrm.com" &&
      hostname !== "www.agentbookcrm.com" &&
      hostname.endsWith(".agentbookcrm.com")
    );
  }, [hostname]);

  const isDemoMode = useMemo(() => {
    return Boolean(demoToken || demoSession);
  }, [demoToken, demoSession]);

  useEffect(() => {
    const bootstrapDemoSession = async () => {
      if (!isSubdomainHost || !demoToken) {
        setBootstrappingDemo(false);
        return;
      }

      try {
        const res = await fetch(`${API_BASE_URL}/api/demo-accounts/bootstrap-session`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ token: demoToken })
        });

        const data = await res.json();

        if (!res.ok) {
          throw new Error(data.message || "Unable to start demo session");
        }

        setAuthSession({
          token: data.authToken,
          user: data.user || {},
          demoSession: data.demoSession || {}
        });

        const cleanUrl = `${window.location.origin}${window.location.pathname}`;
        window.history.replaceState({}, document.title, cleanUrl);
        window.location.replace(cleanUrl);
        return;
      } catch (err) {
        console.error("Demo bootstrap failed:", err.message);
        clearAuthSession();
      } finally {
        setBootstrappingDemo(false);
      }
    };

    bootstrapDemoSession();
  }, [demoToken, isSubdomainHost]);

  if (demoToken) {
    return (
      <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "inherit" }}>
        Entering Demonstration Mode...
      </div>
    );
  }

  if (isDemoMode) {
    if (bootstrappingDemo) {
      return (
        <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "inherit" }}>
          Entering Demonstration Mode...
        </div>
      );
    }

    return children;
  }

  const token = getStoredToken();
  return token ? children : <Navigate to="/login" state={{ from: location }} replace />;
};

export default PrivateRoute;